// extracted by mini-css-extract-plugin
module.exports = {"tweets":"Tool_tweets__oEMQN"};